import React, { Component } from 'react';
import TextFieldGroup from '../common/TextFieldGroup';
import background from "../../assets/img/auxocoldchainbackground.png";
import "./ConfirmCode.css";
import auxo from "../../assets/img/AUXO-Horiz-fleet.png";
import toastr from "toastr";
import tooltipIcon from "../../assets/img/tooltip.png";
import { connect } from "react-redux";
import UserAuthentication from "../../ducks/UserAuthentication";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import { validateConfirmCodeInput } from "../../validations/auth";
import { WhiteSpinner } from '../common/Spinner/index';
import Users from '../../ducks/Users';
const queryString = require('query-string');


class UserReset extends Component {
  constructor(props) {
    super(props);

    let { token } = this.props.match.params;

    let logedInUser = localStorage.getItem('token');
    if(logedInUser){
      toastr.error("Another user already logged in, please logout and activate your account.");
      this.props.history.push("/")
    }
    this.state = {
      token,
      password: "",
      confirmPassword: "",
      errors: {},
      loader: false,
      isValid: true,
      user : '',
      message: ''
    }
    
  }
   ResendLink = async()=> {
    try {
      if (this.state.isValid==0) {
        this.setState({loader : true});
        const userCred = {
          token: this.state.token,
        }
        //Get User
        let user = await this.props.actions.getUserByToken(userCred);
        console.log("USER: ", user);

        const response = await this.props.userActions.resendLink(user.data);
        this.setState({loader : false});

        if(response.success) {
          toastr.success(response.message);
        }
        else {
          toastr.error(response.message);
        }

        console.log("RESPONSE: ", response);
    }

    }
    catch(e) {
      console.log(e);
    }
  }

  async componentDidMount() {
    this.validateCode();
  }

  validateCode = async() => {
    const userCred = {
      token: this.state.token,
    }
    let data = await this.props.actions.checkLinkValidity(userCred);
    console.log("DATA: ", data);

    this.setState({isValid: data.success});
    if(data.success !== 1) {
      toastr.error(data.message);
    }

    console.log("IS VALID: ", this.state.isValid);

  }
  isValid = () => {
    const { errors, isValid } = validateConfirmCodeInput(this.state);
   
    return isValid;
  };

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value, errors: { ...this.state.errors, [e.target.name]: '' } });
  };
  onSubmit = async e => {
    e.preventDefault();
    if (this.isValid()) {

      this.setState({ ...this.state, loader: true })
      try {
        const userCred = {
          token: this.state.token,
          password: this.state.password
        }
        let data = await this.props.actions.confirmCode(userCred);
        this.setState({ ...this.state, loader: false })
        if (data.success){
          toastr.success(data.message);
        } else {
          toastr.error(data.message);
        }
        this.props.history.push("/login");
      }
      catch (error) {
        if (error.response) {
          const data = error.response.data.message;
          toastr.error(data);
        }
        else {
          toastr.error(error);
        }
        this.setState({ ...this.state, loader: false })
      }
    }
  };

  render() {
    
    const labelIcon = {
      icon: tooltipIcon,
      text: "Password must be 8 characters long containing numbers, special characters, uppercase and lowercase letters."
    }
    const loader = <WhiteSpinner key="1" />
    return (
      <div className="justify-content-md-center login-container " style={{ backgroundImage: background }}>
        <div className="login-box mt-lg-5">
          <div className="row">
            <img className="login-logo" src={auxo} alt="" />
          </div>
         { this.state.isValid ===0?
            <button onClick={this.ResendLink} className="btn btn-success btn-login" style={{marginTop: '10%'}}>{this.state.loader ? [loader] :"Resend Link"}</button>
            : this.state.isValid ===-1?
            <button className="btn btn-danger btn-login" style={{marginTop: '10%'}} disabled>Account already created. Goto Login Page</button>
            :
            <form className={"login-form"} onSubmit={this.onSubmit}>
              <TextFieldGroup
                field={"password"}
                placeholder={"Enter Your New Password"}
                value={this.state.password}
                label={"Set Your Password"}
                type={"password"}
                labelIcon={labelIcon}
                onChange={this.onChange}
                error={this.state.errors.password} />

              <TextFieldGroup
                field={"confirmPassword"}
                placeholder={"Please retype your new password"}
                value={this.state.confirmPassword}
                label={"Retype Your Password"}
                type={"password"}
                onChange={this.onChange}
                error={this.state.errors.confirmPassword} />
                <div className="mt-lg-5">
                  <button className="btn btn-success btn-login" type="submit">{this.state.loader ? [loader] : 'Set Password'}</button>
                </div>
                <div className={"help-link-section"}>
                  <Link to="/login">log In</Link>
                </div>
            </form>
          }
         
        </div>
      </div>
    );
  }
}

UserReset.propTypes = {};
UserReset.defaultProps = {};
const mapDispatchToProps = dispatch => ({ 
  actions: bindActionCreators(UserAuthentication.creators, dispatch),
  userActions: bindActionCreators(Users.creators, dispatch) 
});
export default connect(null, mapDispatchToProps)(UserReset);
